import React from "react";

const Landing = () => {
  return <div>Landing</div>;
};

export default Landing;
